import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-993cc324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"0.5rem"} }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "客户营收管理")
], -1))
const _hoisted_3 = { style: {"margin-top":"8px","margin-bottom":"8px"} }
const _hoisted_4 = { style: {"margin-bottom":"8px"} }
const _hoisted_5 = { class: "rightContainer" }
const _hoisted_6 = { class: "rightTotal" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "当月总收入（万元）", -1))
const _hoisted_8 = { class: "total-number center-rate" }
const _hoisted_9 = { class: "rightContainer" }
const _hoisted_10 = { class: "rightTotal" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "当月新客收入（万元）", -1))
const _hoisted_12 = { class: "total-number center-rate" }
const _hoisted_13 = { class: "rightContainer" }
const _hoisted_14 = { class: "rightTotal" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "当月老客收入（万元）", -1))
const _hoisted_16 = { class: "total-number center-rate" }

import { onMounted, PropType, ref, watch } from 'vue'
import SellerMonthlyTargetCompletion
  from '@/views/gucangSales/dataBoard/region/componects/SellerMonthlyTargetCompletion.vue'
import RegionTargetCompletion from '@/views/gucangSales/dataBoard/region/componects/RegionTargetCompletion.vue'
import RegionNewActivatedCustomerCount from '@/views/gucangSales/dataBoard/region/componects/RegionNewActivatedCustomerCount.vue'
import { getRegionCustomerRevenueDataBoard } from '@/api/gucangSales/regionDataBoard'
import RegionRevenueManagementGauge
  from '@/views/gucangSales/dataBoard/region/componects/RegionRevenueManagementGauge.vue'
import RegionTargetCompletionList from '@/views/gucangSales/dataBoard/region/componects/RegionTargetCompletionList.vue'


const __default__ = {
  name: 'Tab3'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props
const keyData = ref<any>({})
onMounted(() => {
  getCustomerRevenueDashData()
})
watch(
  () => props.formState,
  (val) => {
    getCustomerRevenueDashData()
  }
)
const getCustomerRevenueDashData = () => {
  getRegionCustomerRevenueDataBoard(props.formState).then((res: any) => {
    const { data } = res
    // 当月总收入
    keyData.value.salesAmountTotal = data?.salesAmountTotal ?? 0
    // 当月新客收入
    keyData.value.salesAmount = data?.salesAmount ?? 0
    // 当月老客收入
    keyData.value.oldSalesAmount = data?.oldSalesAmount ?? 0
    // 当月预算目标完成率
    const monthBudgetCompletionRateData = data?.monthBudgetCompletionRate
    if (monthBudgetCompletionRateData) {
      keyData.value.monthBudget = {
        rateValue: monthBudgetCompletionRateData.budgetTargetValue ? Number((((monthBudgetCompletionRateData.budgetCompletionValue ?? 0) / monthBudgetCompletionRateData.budgetTargetValue) * 100).toFixed(2)) : 0,
        targetValue: monthBudgetCompletionRateData.budgetTargetValue,
        completeValue: monthBudgetCompletionRateData.budgetCompletionValue
      }
    }

    // 年度预算目标完成率
    const yearBudgetCompletionRateData = data?.yearBudgetCompletionRate
    if (yearBudgetCompletionRateData) {
      keyData.value.yearBudget = {
        rateValue: yearBudgetCompletionRateData.budgetTargetValue ? Number((((yearBudgetCompletionRateData.budgetCompletionValue ?? 0) / yearBudgetCompletionRateData.budgetTargetValue) * 100).toFixed(2)) : 0,
        targetValue: yearBudgetCompletionRateData.budgetTargetValue,
        completeValue: yearBudgetCompletionRateData.budgetCompletionValue
      }
    }

    // 当月利润目标完成率
    const monthProfitCompletionRateData = data?.monthProfitCompletionRate
    if (monthProfitCompletionRateData) {
      keyData.value.monthProfit = {
        rateValue: monthProfitCompletionRateData.profitTargetValue ? Number((((monthProfitCompletionRateData.profitCompletionValue ?? 0) / monthProfitCompletionRateData.profitTargetValue) * 100).toFixed(2)) : 0,
        targetValue: monthProfitCompletionRateData.profitTargetValue,
        completeValue: monthProfitCompletionRateData.profitCompletionValue
      }
    }

    // 年度利润目标完成率
    const yearProfitCompletionRateData = data?.yearProfitCompletionRate
    if (yearProfitCompletionRateData) {
      keyData.value.yearProfit = {
        rateValue: yearProfitCompletionRateData.profitTargetValue ? Number((((yearProfitCompletionRateData.profitCompletionValue ?? 0) / yearProfitCompletionRateData.profitTargetValue) * 100).toFixed(2)) : 0,
        targetValue: yearProfitCompletionRateData.profitTargetValue,
        completeValue: yearProfitCompletionRateData.profitCompletionValue
      }
    }
    // matchItem.targetValueTotal ? Number((((matchItem.completionValueTotal ?? 0) / matchItem.targetValueTotal) * 100).toFixed(2)) : 0
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_row, { gutter: 8 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(SellerMonthlyTargetCompletion, {
              formState: props.formState
            }, null, 8, ["formState"]),
            _createVNode(RegionTargetCompletion, {
              formState: props.formState
            }, null, 8, ["formState"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(RegionRevenueManagementGauge, {
              appId: "cos_fbu",
              title: "年度预算目标完成率",
              value: keyData.value.yearBudget
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(RegionRevenueManagementGauge, {
                appId: "cos_fbu",
                title: "当月预算目标完成率",
                value: keyData.value.monthBudget
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(RegionRevenueManagementGauge, {
                appId: "cos_fbu",
                title: "年度利润目标完成率",
                value: keyData.value.yearProfit
              }, null, 8, ["value"])
            ]),
            _createVNode(RegionRevenueManagementGauge, {
              appId: "cos_fbu",
              title: "当月利润目标完成率",
              value: keyData.value.monthProfit
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("span", _hoisted_8, _toDisplayString(keyData.value.salesAmountTotal), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("span", _hoisted_12, _toDisplayString(keyData.value.salesAmount), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("span", _hoisted_16, _toDisplayString(keyData.value.oldSalesAmount), 1)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(RegionNewActivatedCustomerCount, {
              formState: props.formState
            }, null, 8, ["formState"]),
            _createVNode(RegionTargetCompletionList, {
              formState: props.formState
            }, null, 8, ["formState"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})